import {AutoReplyTypeEnum} from '../../../../../service/reviews/reviews-response-templates';

// Values match reviews autoreply rule `replyType` and query param `autoreply` (see AutoReplyTypeEnum).
export enum AutoReplayEnum {
    template = AutoReplyTypeEnum.Template,
    neuralNetwork = AutoReplyTypeEnum.NeuralNetwork,
}

// GET /v4/reviews/?autoreply=… — query string values (internal filter still uses AutoReplyTypeEnum).
enum AutoreplyQueryParameterEnum {
    templateAutoreply = 'template_autoreply',
    neuralNetworkAutoreply = 'neural_network_autoreply',
}

export function getAutoreplyQueryParameterForFilter(internal: string): string {
    switch (internal) {
        case AutoReplyTypeEnum.Template:
            return AutoreplyQueryParameterEnum.templateAutoreply;
        case AutoReplyTypeEnum.NeuralNetwork:
            return AutoreplyQueryParameterEnum.neuralNetworkAutoreply;
        default:
            return internal;
    }
}

// do not change values, they matched with server's api
export enum ContentOfReviewsEnum {
    noSelected = '',
    reviewsWithoutText = 'true',
    reviewsWithText = 'false',
}

// do not change values, they matched with server's api
export enum DeletedReviewsEnum {
    noSelected = '',
    yes = 'true',
    no = 'false',
}

// do not change values, they matched with server's api
export enum EmployeesReviewsEnum {
    all = 'True',
    noSelected = 'null',
}

// do not change values, they matched with server's api
export enum DoctorsReviewsEnum {
    all = 'True',
}

// do not change values, they matched with server's api
export enum RepliesToReviewsEnum {
    noSelected = '',
    ReviewsWithAResponse = 'true',
    ReviewsUnanswered = 'false',
}

// do not change values, they matched with server's api
export enum PossibilityOfAnAnswerEnum {
    noSelected = '',
    HasPossibilityOfAnAnswer = 'true',
    HasNoPossibilityOfAnAnswer = 'false',
}

// do not change values, they matched with server's api
export enum ReviewNameEnum {
    noSelected = '',
    ReviewsForTheBrand = 'brand',
    ReviewsForCompanies = 'company',
}

// do not change values, they matched with server's api (draft DEV-19207)
export enum AbuseStatusEnum {
    noSelected = '',
    notSent = 'not_sent',
    sent = 'sent',
    accepted = 'accepted',
    declined = 'declined',
}

// do not change values — same as legacy query `is_autoabuse` (boolean as string): auto → true, manual → false
export enum AutoAbuseEnum {
    notSelected = '',
    yes = 'true',
    no = 'false',
}

// do not change values, they matched with server's api
export enum ReviewChangedEnum {
    noSelected = '',
    yes = 'true',
    no = 'false',
}

// do not change values, they matched with server's api
export enum WaitingForSecondAnswerEnum {
    noSelected = '',
    yes = 'true',
    no = 'false',
}

export enum ModeratedEnum {
    noSelected = '',
    yes = 'true',
    no = 'false',
}

export enum WithoutTagEnum {
    noSelected = '',
    withoutTagTrue = 'true',
    withoutTagFalse = 'false',
}

export enum ReviewsFilterFieldNameEnum {
    brandIds = 'brand_ids',
    sourceList = 'source-list',
    processStatus = 'process_status',
    ratingList = 'rating-list',
    employeesResponsible = 'employee-responsible',
    employeesResponding = 'employee-responding',
    doctorNames = 'doctors-name',
    allDoctors = 'all-doctors',
    tagList = 'tag-list',
    withoutTag = 'without-tag',

    autoReplay = 'auto-replay',
    contentOfReviews = 'content-of-reviews',
    deletedReviews = 'deleted-reviews',
    repliesToReviews = 'replies-to-reviews',
    possibilityOfAnAnswer = 'possibility-of-an-answer',
    reviewType = 'review-type',
    abuseStatus = 'abuse-status',
    autoAbuse = 'auto-abuse',
    reviewChanged = 'review-changed',
    waitingForSecondAnswer = 'waiting-for-second-answer',
    reviewModerated = 'moderated',

    dateFrom = 'date-from',
    dateTo = 'date-to',
    collectionDateFrom = 'collection-date-from',
    collectionDateTo = 'collection-date-to',
    replyDateFrom = 'reply-date-from',
    replyDateTo = 'reply-date-to',
    agencyRepliers = 'agency-repliers',
    customProcessStatus = 'custom_process_status',
}

export type ReviewsFilterDataType = Readonly<{
    [ReviewsFilterFieldNameEnum.brandIds]: number | null;
    [ReviewsFilterFieldNameEnum.sourceList]: Array<number>;
    [ReviewsFilterFieldNameEnum.processStatus]: Array<string>;
    [ReviewsFilterFieldNameEnum.customProcessStatus]: Array<string>;
    [ReviewsFilterFieldNameEnum.ratingList]: Array<number>;
    [ReviewsFilterFieldNameEnum.employeesResponding]: Array<string | number>;
    [ReviewsFilterFieldNameEnum.employeesResponsible]: Array<string | number>;
    [ReviewsFilterFieldNameEnum.doctorNames]: Array<string>;
    [ReviewsFilterFieldNameEnum.tagList]: Array<number>;
    [ReviewsFilterFieldNameEnum.withoutTag]: WithoutTagEnum;
    [ReviewsFilterFieldNameEnum.autoReplay]: Array<string>;
    [ReviewsFilterFieldNameEnum.contentOfReviews]: ContentOfReviewsEnum;
    [ReviewsFilterFieldNameEnum.deletedReviews]: DeletedReviewsEnum;
    [ReviewsFilterFieldNameEnum.repliesToReviews]: RepliesToReviewsEnum;
    [ReviewsFilterFieldNameEnum.possibilityOfAnAnswer]: PossibilityOfAnAnswerEnum;
    [ReviewsFilterFieldNameEnum.reviewType]: ReviewNameEnum;
    [ReviewsFilterFieldNameEnum.abuseStatus]: Array<string>;
    [ReviewsFilterFieldNameEnum.autoAbuse]: AutoAbuseEnum;
    [ReviewsFilterFieldNameEnum.reviewChanged]: ReviewChangedEnum;
    [ReviewsFilterFieldNameEnum.waitingForSecondAnswer]: WaitingForSecondAnswerEnum;
    [ReviewsFilterFieldNameEnum.reviewModerated]: ModeratedEnum;
    [ReviewsFilterFieldNameEnum.dateFrom]: Date | null;
    [ReviewsFilterFieldNameEnum.dateTo]: Date | null;
    [ReviewsFilterFieldNameEnum.collectionDateFrom]: Date | null;
    [ReviewsFilterFieldNameEnum.collectionDateTo]: Date | null;
    [ReviewsFilterFieldNameEnum.replyDateFrom]: Date | null;
    [ReviewsFilterFieldNameEnum.replyDateTo]: Date | null;
    [ReviewsFilterFieldNameEnum.agencyRepliers]: Array<number | string>;
}>;

export type ReviewsFilterDataAsObjectUrlType = Readonly<Partial<Record<ReviewsFilterFieldNameEnum, string | void>>>;
